// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f-render-right{width:310px;height:100%}.f-render-right .form-item-placeholder{height:300px;line-height:300px;color:#909399;text-align:center}.f-render-right .el-tabs__header{padding-top:20px}.f-render-right .el-tabs__nav-wrap{padding:0 15px}.f-render-right .el-tabs__item{padding:0 10px}.f-render-right .el-tabs__nav-wrap:after{height:0}.f-render-right .el-tabs__active-bar{height:1px!important}.f-render-right .f-render-right-content{padding:20px 0}", ""]);
// Exports
module.exports = exports;
